/**
* Pinned Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Pinned Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'pinned-left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.pinned-left-right' ).each( function( key, val ) {
        if ( window.innerWidth > 768 ) {
          const contentHeight = $( this ).find( '.content-col' ).outerHeight();
          const height = $( this ).outerHeight();

          let navHeight = $( '.navbar' ).outerHeight();

          if ( $( '#wpadminbar' ).length ) {
            navHeight += $( '#wpadminbar' ).outerHeight();
          }

          // const imagePinner = gsap.timeline( {
          //   scrollTrigger: {
          //     trigger: this,
          //     start: ( $( this ).find( '.images-area .image-wrapper' ).outerHeight() / 2 ) + ' ' + ( navHeight + ( window.innerHeight - navHeight ) / 2 ),
          //     end: '+=' + ( ( contentHeight - $( this ).find( '.images-area .image-wrapper' ).outerHeight() ) - 0 ),
          //     pin: $( this ).find( '.images-area' )[0],
          //     pinSpacing: false,
          //     // markers: true,
          //   },
          // } );

          $( this ).find( '.section' ).each( function( sectionKey, sectionVal ) {
            const contentFader = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                start: 'top 75%',
                end: '+=' + ( $( this ).outerHeight() * 0.5 ),
                scrub: true,
              },
            } );
            contentFader.to( this, {opacity: '1', ease: 'linear'} );
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'pinned-left-right', COMPONENT );
} )( app );
